import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { logActivity } from "../services/activity";

// Les pages de suivi (/alain, /jay…) ne sont pas journalisées : ce sont
// les organisateurs qui les consultent, pas les visiteurs.
const ADMIN_PATHS = ["/alain", "/jay", "/versions"];

// Évite un doublon quand React (StrictMode, en dev) rejoue l'effet.
let lastLoggedPath = "";

export default function ActivityTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === lastLoggedPath) {
      return;
    }

    lastLoggedPath = pathname;

    // React Router ignore la casse : /JAY ouvre aussi la page /jay.
    const path = pathname.toLowerCase();

    if (!ADMIN_PATHS.some((p) => path.startsWith(p))) {
      logActivity("page_view");
    }
  }, [pathname]);

  return null;
}
